import { spreadByBreakpoints } from './media-spread';
import { sizes } from '../breakpoints';
import media from '../media';
import { isDefined } from './defined';
export const styleForBreakpoints = (props, getStyleFn, needSpreadProps = true) => {
  if (needSpreadProps) {
    const spreadProps = spreadByBreakpoints(props, true);
    return sizes.map(size => media.only[size]`${getStyleFn(spreadProps[size], size)}`);
  } else {
    return sizes.map(size => media.only[size]`${getStyleFn(props[size], size)}`);
  }
};
export const styleArrayForBreakpoints = (props, getStyleFn, needSpreadProps = true) => {
  if (needSpreadProps) {
    const spreadProps = props.map(value => spreadByBreakpoints(value, true));
    return sizes.map(breakpoint => media.only[breakpoint]`${getStyleFn(spreadProps.map(value => value[breakpoint]), breakpoint)}`);
  } else {
    return sizes.map(breakpoint => media.only[breakpoint]`${getStyleFn(props.map(value => value[breakpoint]), breakpoint)}`);
  }
};
export const styleFlagForBreakpoints = (flag, style, needSpreadProps = true) => {
  if (!isDefined(flag)) {
    return '';
  }
  if (typeof flag === 'boolean') {
    return flag ? style : '';
  }
  return styleForBreakpoints(flag, flag => flag ? style : '', needSpreadProps);
};